module.exports = __webpack_public_path__ + "img/cocina-2.737eae08.jpg";